import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';
import styles from './styles';

const stylesLocal = {
  root: {
    width: '100%',
  },
};

const LocalPostCodeSearchField = props => {
  const {
    initialLocation,
    setLocalLocation,
    classes,
    dispatchApiCallFailed,
    dispatchApiCallSuccess,
  } = props;
  const [address, setAddress] = useState(initialLocation || '');

  // eslint disable required - autocomplete has peculiar functionality w/ requiring state name to be passed.
  // eslint-disable-next-line no-shadow
  const handleChange = address => {
    setAddress(address);
  };

  // eslint-disable-next-line no-shadow
  const handleSelect = address => {
    geocodeByAddress(address)
      .then(results => {
        dispatchApiCallSuccess();
        setLocalLocation(results[0].formatted_address);
        setAddress(results[0].formatted_address);
      })
      .catch(() => {
        dispatchApiCallFailed();
      });
  };

  return (
    <PlacesAutocomplete
      style={stylesLocal.root}
      value={address}
      onSelect={handleSelect}
      onChange={handleChange}
      searchOptions={{
        componentRestrictions: { country: 'au' },
        types: ['(regions)'],
      }}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div className={classes.root}>
          <TextField
            {...getInputProps({})}
            style={stylesLocal.root}
            placeholder="Location of Job"
            label="Location of Job"
            InputLabelProps={{ shrink: true }}
          />
          <div className="autocomplete-dropdown-container">
            {loading && <div>Loading...</div>}
            {suggestions.map(suggestion => {
              const className = suggestion.active
                ? 'suggestion-item--active'
                : 'suggestion-item';
              // inline style for demonstration purpose
              const style = suggestion.active
                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                : { backgroundColor: '#ffffff', cursor: 'pointer' };
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};

LocalPostCodeSearchField.propTypes = {
  initialLocation: PropTypes.string,
  setLocalLocation: PropTypes.func,
  classes: PropTypes.any,
  dispatchApiCallFailed: PropTypes.func,
  dispatchApiCallSuccess: PropTypes.func,
};

export default withStyles(styles)(LocalPostCodeSearchField);
